import React, { useEffect, useState } from "react";
import { X } from "lucide-react";
import { api, fileUrl } from "@/lib/api";

// Shows active admin ads one-by-one after login, then reveals the app.
export default function AdsGate({ children }) {
  const [ads, setAds] = useState(null);
  const [idx, setIdx] = useState(0);
  const [done, setDone] = useState(() => sessionStorage.getItem("ecfd_ads_seen") === "1");

  useEffect(() => {
    if (done) return;
    api.get("/ads").then(({ data }) => {
      if (!data || data.length === 0) { finish(); } else { setAds(data); }
    }).catch(finish);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const finish = () => { sessionStorage.setItem("ecfd_ads_seen", "1"); setDone(true); };
  const next = () => { if (idx + 1 < ads.length) setIdx(idx + 1); else finish(); };

  if (!done && ads && ads.length > 0) {
    const ad = ads[idx];
    return (
      <div className="fixed inset-0 z-[100] bg-black/90 flex items-center justify-center p-4" data-testid="ads-overlay">
        <div className="relative max-w-2xl w-full animate-fadeUp">
          <button onClick={next} data-testid="ad-close-button"
            className="absolute -top-3 -end-3 z-10 w-10 h-10 rounded-full bg-orange-600 hover:bg-orange-500 flex items-center justify-center text-pure shadow-lg">
            <X className="w-5 h-5" />
          </button>
          <img src={fileUrl(ad.image)} alt={`Ad ${ad.slot}`} onError={next} className="w-full max-h-[80vh] object-contain rounded-2xl border border-white/10" data-testid={`ad-image-${ad.slot}`} />
          <div className="flex justify-center gap-2 mt-4">
            {ads.map((_, i) => <span key={i} className={`h-1.5 rounded-full transition-all ${i === idx ? "w-8 bg-orange-500" : "w-2 bg-white/20"}`} />)}
          </div>
          <p className="text-center text-gray-400 text-sm mt-3">Tap ✕ to continue{idx + 1 < ads.length ? " to next ad" : " to your dashboard"}</p>
        </div>
      </div>
    );
  }
  return children;
}
